// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1xRpc","footer":"ReportModalFilter_footer__3tG-J"};